import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import RecurrentPaymentContext from "../../../../../infrastructure/Contexts/components/data/RecurrentPaymentsWrapper/context";
import RecurrentPaymentAction from "../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import ModalContext from "../../../../../infrastructure/Contexts/components/ModalWrapper/context";
import CobeeButton from "../../../CobeeButton";
import { MonetaryAmount } from "../../../../domain/monetary-amount";
import useStyles from "./styles";
import AcceptRentingModal from "../AcceptRentingModal";

export default function RentingResultsModal(): JSX.Element {
  const { rentingDetails, recurrentPaymentDetail } = useContext(
    RecurrentPaymentContext
  );
  const { openModal, closeModal } = useContext(ModalContext);
  const { approveRenting, approveRentingIsLoading } = useContext(
    RecurrentPaymentAction
  );
  const { id } = recurrentPaymentDetail;

  const { container, buttonRow, divider, row } = useStyles();

  const prettifyMoney = (value) =>
    value && MonetaryAmount.ofCurrency(value).prettifyMoney({});

  const {
    firstPaymentTimestamp,
    lastPaymentTimestamp,
    firstPaymentAmount,
    amountPerPayment,
    numberOfPayments,
    totalAmount,
    monthlyAttribution,
  } = rentingDetails;

  return (
    <Grid item container xs={12} className={container}>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.first-quota-date")}:
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          {moment(new Date(firstPaymentTimestamp * 1000)).format("DD/MM/YYYY")}
        </Typography>
      </Grid>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.first-quota-amount")}:
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          {prettifyMoney(firstPaymentAmount)} (
          {t("common-messages.tax-included")})
        </Typography>
      </Grid>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.remaining-quota-amount")}:
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          {prettifyMoney(amountPerPayment)} / {t("common-messages.month")} (
          {t("common-messages.tax-included")})
        </Typography>
      </Grid>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.amount-to-extract-from-payroll")}: (
          {t("request-section.taxes-will-apply-message")})
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          {prettifyMoney(monthlyAttribution)} / {t("common-messages.month")}
        </Typography>
      </Grid>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.number-of-quotas")}:
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">{numberOfPayments}</Typography>
      </Grid>
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          {t("common-messages.last-quote-date")}:
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          {moment(new Date(lastPaymentTimestamp * 1000)).format("DD/MM/YYYY")}
        </Typography>
      </Grid>
      <Grid item xs={12} className={divider} />
      <Grid item xs={5} className={row}>
        <Typography variant="body2">
          <b>{t("request-section.renting-total-amount")}:</b>
        </Typography>
      </Grid>
      <Grid item xs={7} className={row}>
        <Typography variant="body2">
          <b>
            {prettifyMoney(totalAmount)} (
            {t("common-messages.includes-first-quota")})
          </b>
        </Typography>
      </Grid>
      <Grid
        item
        container
        xs={12}
        justifyContent="center"
        alignItems="center"
        className={buttonRow}
      >
        <CobeeButton
          styleType="secondary"
          onClick={() => {
            closeModal();
            openModal({
              title: t("recurrent-payments-section.renting-results"),
              modalContents: <AcceptRentingModal />,
            });
          }}
        >
          {t("actions.go-back")}
        </CobeeButton>
        <CobeeButton
          styleType="primary"
          isLoading={approveRentingIsLoading}
          onClick={() =>
            approveRenting({ requestId: id, rentingData: rentingDetails })
          }
        >
          {t("actions.approve-request")}
        </CobeeButton>
      </Grid>
    </Grid>
  );
}
